/* eslint-disable max-len */
import React from 'react';

interface PlusAndMinusIconProps {
    $expanded: boolean;
}

const PlusAndMinusIcon: React.FC<PlusAndMinusIconProps> = ({$expanded}) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
			{/* Vertical line (plus) */}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.7157 13.7141V11.9998V10.2855V3.4284C13.7157 2.48162 12.9482 1.71411 12.0014 1.71411C11.0546 1.71411 10.2871 2.48162 10.2871 3.4284V10.2855V11.9998V13.7141V20.5713C10.2871 21.518 11.0546 22.2855 12.0014 22.2855C12.9482 22.2855 13.7157 21.518 13.7157 20.5713V13.7141Z"
				fill="#001B74"
				style={{
					transition: 'opacity 0.3s, transform 0.3s',
					opacity: $expanded ? 0 : 1,
					transform: $expanded ? 'scaleY(0.5)' : 'scaleY(1)',
					transformOrigin: 'center',
				}}
			/>
			{/* Horizontal line (minus) */}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.7141 10.2843H11.9998H10.2855H3.4284C2.48162 10.2843 1.71411 11.0518 1.71411 11.9986C1.71411 12.9454 2.48162 13.7129 3.4284 13.7129H10.2855H11.9998H13.7141H20.5713C21.518 13.7129 22.2855 12.9454 22.2855 11.9986C22.2855 11.0518 21.518 10.2843 20.5713 10.2843H13.7141Z"
				fill="#001B74"
			/>
		</svg>
	);
};

export default PlusAndMinusIcon;